"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Icon from "./icon.js";
export const ShareIcon = React.forwardRef(function ShareIcon(props, ref) {
    return (_jsx(Icon, Object.assign({ ref: ref }, props, { children: _jsx("path", { d: "M15.432 7.502h2.282c1.263 0 2.286.896 2.286 2v10c0 1.105-1.023 2-2.286 2H6.286c-1.263 0-2.286-.895-2.286-2v-10c0-1.104 1.023-2 2.286-2h2.289m6.43-2.335l-3-2.667-3 2.667M12 3.5v11" }) })));
});
export default ShareIcon;
//# sourceMappingURL=share.js.map